<template>
  <div class="table-action-wrapper d-flex flex-wrap align-items-center design-review" ref="container">
    <p class="item-selected m-0" v-html="`Selected: ${Object.keys(ids).length} ${Object.keys(ids).length > 1 ? 'items' : 'item'}`"></p>
    <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center">
      <span>Confirm</span>
    </a>
    <div class="position-relative d-flex w-100 mt-2 flex-wrap">
      <div class="col-12 p-0 m-0 supplier-account w-100" ref="supplierAccount">
        <Select :options="vendorOptions" :group="true" placeholder="Account" :value="mapping.vendor_id" @changeValue="handleChangeVendorId" class="flex-1 mr-2"></Select>
      </div>
      <component :is="component" :config="designMappingConfig()" @changeValue="designMappingChange"></component>
    </div>

    <div class="position-relative d-flex w-100 mt-2 input-group flex-nowrap">
      <textarea v-model="actionContent" class="form-control w-100"></textarea>
      <div class="input-group-append">
        <div class="input-group-text flex-column p-0">
          <a @click.prevent="handleAction('accept')" href="#" class="text-success flex-1 p-2">
            <span>Accept</span>
          </a>
          <a @click.prevent="handleAction('exclude')" href="#" class="text-danger flex-1 p-2">
            <span>Exclude</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ids: {},
      actionContent: '',
      component: null,
      vendorOptions: [],
      mapping: {},
      mappingPlatform: null
    }
  },
  mounted() {
    let listStatus = this.store.getter('extra_attributes.status', {})
    let status = 'mapping'
    this.store.commit('query.status', {
      value: status,
      valueLabel: listStatus?.[status]?.text,
      fieldLabel: 'Status'
    })
    this.store.commit('more.blueprint', true)
    this.store.commit('cols.cb.hidden', false)
    this.$emit('change-filters', { search: '' }, { refresh: true, goToFirst: true })
    this.indexVendorId()
    this.$emitter.on('table-list.refreshed', this.tableListRefreshed)
  },
  unmounted() {
    this.store.commit('more.blueprint', false)
    this.store.commit('cols.cb.hidden', true)
    this.$emitter.off('table-list.refreshed', this.tableListRefreshed)
  },
  computed: {
    store() {
      return this.config?.store
    },
    cb() {
      return this.config?.cb
    },
    rows() {
      let data = this.store.getter('rows', {})
      let rows = {}
      Object.entries(data).forEach(([indexRow, item]) => {
        rows[item._id] = item
        rows[item._id].indexRow = indexRow
      })
      return rows
    }
  },
  methods: {
    tableListRefreshed(e) {
      Object.entries(this.ids).forEach(([id]) => {
        e.cb[id] = true
      })
    },
    handleAction(action) {
      if (!confirm('Are you sure?')) {
        return
      }
      let list = this.actionContent.split('\n').map((item) => {
        return item.replace(/\s\s+/gi, ' ').trim().toUpperCase()
      })
      if (action == 'accept') {
        Object.entries(this.ids).forEach(([id, item]) => {
          if (list.indexOf(item.name) == -1) {
            delete this.ids[id]
          }
        })
      } else {
        Object.entries(this.ids).forEach(([id, item]) => {
          if (list.indexOf(item.name) != -1) {
            delete this.ids[id]
          }
        })
      }

      Object.entries(this.rows).forEach(([index, item]) => {
        if (this.ids[index] != undefined) {
          this.store.commit(`rows.${item.indexRow}.cb`, true)
        } else {
          this.store.commit(`rows.${item.indexRow}.cb`, false)
        }
      })
    },
    indexVendorId() {
      this.$util.forceGet('vendor-account', {}, this.$refs.supplierAccount, {
        done: (response) => {
          if (response.status == 'success') {
            this.vendorOptions = Object.values(response.items)
            if (this.$util.getObjectVal(this.vendorOptions, ['0', 'children', '0', 'id']) != null) {
              this.handleChangeVendorId(this.vendorOptions[0].children[0].id)
            }
          } else {
            console.log(response)
          }
        }
      })
    },
    designMappingConfig() {
      return {
        storeId: this.config?.storeId,
        data: {
          mapping: this.mapping
        },
        mapping: this.mapping,
        platform: this.mappingPlatform
      }
    },
    handleChangeVendorId(value) {
      this.vendorOptions.forEach((items) => {
        if (_.isArray(items?.children)) {
          items.children.forEach((item) => {
            if (item?.id == value) {
              this.mappingPlatform = item.platform
            }
          })
        } else {
          if (items?.id == value) {
            this.mappingPlatform = items.platform
          }
        }
      })

      if (this.mappingPlatform) {
        let platform = _.pascalCase(this.mappingPlatform || '')
        let component = `${platform}.Design.DesignMapping`
        if (this.$options.components[component] == undefined) {
          this.$options.components[component] = this.$util.requireOrNull(`/platforms/${platform}/Design/DesignMapping.vue`)
        }

        if (this.$options.components[component] !== null) {
          this.component = component
          this.mapping.vendor_id = value
        } else {
          this.$util.notify({
            text: 'Platforms not supported!',
            status: 'error'
          })
        }
      }
    },
    designMappingChange(value) {
      this.mapping = Object.assign(this.mapping, value)
    },
    submit() {
      this.$util
        .post(
          'design/more/update-status',
          {
            ids: Object.keys(this.ids).join(','),
            mapping: this.mapping,
            status: 'completed'
          },
          this.$refs.container
        )
        .then((response) => {
          if (response.status == 'success') {
            this.ids = {}
            this.actionContent = ''
            this.$emitter.emit('TableList.Refresh')
          }
        })
    }
  },
  watch: {
    cb: {
      handler(values) {
        Object.entries(values).forEach(([id, checked]) => {
          if (checked) {
            this.ids[id] = {
              name: this.rows?.[id]?.design?.name.replace(/\s\s+/gi, ' ').trim().toUpperCase(),
              url: this.rows?.[id]?.design?.blueprint || ''
            }
          } else if (this.ids[id] != undefined) {
            delete this.ids[id]
          }
        })
      },
      deep: true
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.table-action-wrapper.design-review {
  .item-selected {
    width: 140px;
  }
  .input-group {
    a {
      width: 100%;
      &:hover {
        background: #d1eeff;
      }
    }
  }
}
</style>
